<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="Rubicon"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/em-rubicon-01.webp"
            class="grey lighten-2"
            cover
            :min-height="breakpoint ? '' : 750"
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <div class="overlay">

              <!-- TODO wrap on small display -->
              <v-row
                class="fill-height max-width-1200 mx-auto"
                align="center"
                justify="center">
                <v-col cols="12" class="max-width-500 mr-auto">
                  <v-row>
                    <v-col class="text-start">
                      <span class="product-brand">{{$t("rubin.rubin")}}</span><br>
                      <span class="product-name">{{ $t('energyManagement.service.rubicon.title') }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(item,index) in pros"
                    :key="index">
                    <v-col class="text-start product-pro border-bottom-light">
                      {{ $t(item.short) }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- ic img -->
              <v-row class="carousel-bottom-controls">
                <v-col class="pa-0 img-ic-box flip-x">
                </v-col>
              </v-row>

              <!-- landing scroll menu -->
              <v-row class="menu landing-scroll">
                <v-col class="max-width-1200 px-0 mx-auto">
                  <v-btn
                    id="back" name="back" title="back"
                    text dark
                    @click="loadPage('EnergyManagement')">
                      <v-icon>
                        mdi-chevron-double-left
                      </v-icon>
                  </v-btn>
                  <v-btn
                    v-for="(item,index) in sections"
                    :key="index"
                    text dark
                    @click="scrollTOSection(item.id)">
                      {{ $t(item.title) }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-img>

        </v-card>

        <v-row class="mx-1">
          <v-col id="about">
            <About></About>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="technology">
            <Technology></Technology>
          </v-col>
        </v-row>
        <!-- <v-row class="">
          <v-col id="software">
            <Software></Software>
          </v-col>
        </v-row> -->
        <v-row class="mx-1">
          <v-col id="studies">
            <Studies></Studies>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-ruby">
          <v-col id="contact">
            <Contact></Contact>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import About from '@/components/EnergyManagement/Rubicon/About.vue'
  import Software from '@/components/EnergyManagement/Rubicon/Software.vue'
  import Technology from '@/components/EnergyManagement/Rubicon/Technology.vue'
  import Studies from '@/components/EnergyManagement/Rubicon/Studies.vue'
  import Contact from '@/components/Common/Contact.vue'


  export default {
    name: 'Rubicon',
    metaInfo: {
      title: 'Rubicon',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Komplex épület-, távfelügyeleti szolgáltatás rendszerek integrálásával. Távfelügyelet, teremhűtés,   helymeghatározás, üzemeltetési költségcsökkentés.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'távfelügyelet, üzemeltetés, épületfelügyelet, terem hűtés,  Szervertermi mérések'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      About,
      Software,
      Technology,
      Studies,
      Contact,
    },

    data: () => ({
      pros: [
        { title: "", short: "rubicon.pros.01.short", component: "",},
        { title: "", short: "rubicon.pros.02.short", component: "",},
        { title: "", short: "rubicon.pros.03.short", component: "",},
        // { title: "", short: "energyMonitor.sections.pros.04.short", component: "",},
        // { title: "", short: "energyMonitor.sections.pros.05.short", component: "",},
        // { title: "", short: "energyMonitor.sections.pros.06.short", component: "",},
      ],
      sections: [
        { id: "about",          title: "common.about", },
        { id: "technology",     title: "rubicon.technology.title", },
        // { id: "software",       title: "rubicon.software.title", },
        { id: "studies",        title: "common.studies", },
      ],
    }),

    mounted() {
    },

    computed: {
      breakpoint() {
        if (this.computedWidth < 961) {
          return true
        } else {
          return false
        }
      },
      computedCarouselHeight() {
        return this.styleProps.windowHeight;
      },
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },
  }

</script>

<style src="../../Style.css">
</style>
